import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"mt-10"},[_c('div',{staticClass:"error-page"},[_c('div',[_c('h1',{attrs:{"data-h1":"404"}},[_vm._v("404")]),_c('p',{attrs:{"data-p":"NOT FOUND"}},[_vm._v("NOT FOUND")])])]),_c('div',{staticClass:"text-center"},[_c(VBtn,{attrs:{"large":"","color":"primary","to":"/","outlined":""}},[_vm._v("Home "),_c(VIcon,[_vm._v(_vm._s(_vm.mdilHome))])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }